var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12ZM3.81818 12C3.81818 16.5115 7.48848 20.1818 12 20.1818C16.5115 20.1818 20.1818 16.5115 20.1818 12C20.1818 7.48855 16.5115 3.81818 12 3.81818C7.48848 3.81818 3.81818 7.48855 3.81818 12ZM10.6072 13.6071L15.7498 8.46448C16.1049 8.10945 16.6804 8.10952 17.0355 8.46454C17.3905 8.81957 17.3905 9.39515 17.0355 9.75018L11.2499 15.5356C11.0795 15.706 10.8482 15.8018 10.6072 15.8018H10.6071C10.366 15.8018 10.1348 15.706 9.96431 15.5355L6.96455 12.5356C6.60952 12.1806 6.60952 11.605 6.96455 11.25C7.31958 10.895 7.89521 10.8951 8.25018 11.2501L10.6072 13.6071Z",
    fill: "#23C983"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlined);
export default __webpack_public_path__ + "static/media/checkOutlined.51d518c9d6ecd8b2d0a7e985b5e98f6f.svg";
export { ForwardRef as ReactComponent };